<!-- 通投推广页面 -->
<template>
	<div class="chat-landing-page">
		<!-- 轮播图区域 -->
		<div class="carousel-container">
			<div class="carousel-wrapper" ref="carouselWrapper" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
				<div 
					v-for="(image, index) in carouselImages" 
					:key="index"
					class="carousel-slide"
				>
					<img :src="image.src" :alt="image.alt" class="carousel-image" />
				</div>
			</div>
			
			<!-- 轮播指示器 -->
			<div class="carousel-indicators">
				<span 
					v-for="(image, index) in carouselImages" 
					:key="index"
					class="indicator"
					:class="{ active: currentSlide === index }"
					@click="goToSlide(index)"
				></span>
			</div>
			
		</div>

		<!-- 聊天内容区域 -->
		<div class="chat-container" ref="chatContainer">
			<!-- 动态显示的消息 -->
			<div 
				v-for="(message, index) in visibleMessages" 
				:key="index"
				class="message"
				:class="message.type"
				:style="{ animationDelay: message.type === 'user-message' ? '0s' : (index * 0.2) + 's' }"
			>
				<div class="message-avatar" v-if="message.type === 'university-message'">
					<div class="uibe-logo">
						<img src="../../img/logo.png" alt="logo" class="logo-img"></img>
					</div>
				</div>
				<div class="message-bubble" :class="message.bubbleClass">
					<div class="message-content">
						<p v-for="(line, lineIndex) in message.content" :key="lineIndex" v-html="line"></p>
						<div v-if="message.hasMajorOptions && !selectedMajorValue" class="major-options-inline">
							<span 
								v-for="major in majorOptions" 
								:key="major.value"
								class="major-option-tag" 
								@click="selectMajorFromMessage(major.value)"
							>
								{{ major.label }}
							</span>
						</div>
						<div v-if="message.hasEducationOptions && !selectedEducationValue" class="education-options-inline">
							<span 
								v-for="education in educationOptions" 
								:key="education.value"
								class="education-option-tag" 
								@click="selectEducationFromMessage(education.value)"
							>
								{{ education.label }}
							</span>
						</div>
						<div v-if="message.hasPositionOptions && !selectedPositionValue" class="position-options-inline">
							<span 
								v-for="position in positionOptions" 
								:key="position.value"
								class="position-option-tag" 
								@click="selectPositionFromMessage(position.value)"
							>
								{{ position.label }}
							</span>
						</div>
					</div>
				</div>
				<div class="message-avatar user-avatar" v-if="message.type === 'user-message'">
					<div class="user-icon">👤</div>
				</div>
			</div>

			<!-- 弹窗遮罩 -->
			<div class="modal-overlay" v-if="showModal" @click="closeModal">
				<div class="modal-container" @click.stop>
					<div class="modal-header">
						<h3>填写联系信息</h3>
						<button class="close-btn" @click="closeModal">&times;</button>
					</div>
					<div class="modal-body">
						<form  class="registration-form">
							<div class="form-group">
								<label>姓名</label>
								<input 
									type="text" 
									v-model="formData.name" 
									class="form-input"
									placeholder="请输入您的姓名"
									required
								/>
							</div>

							<div class="form-group">
								<label>手机号码</label>
								<input 
									type="tel" 
									v-model="formData.mobile" 
									class="form-input"
									:class="{ 'error': mobileError }"
									placeholder="请输入手机号码"
									@input="validateMobile"
									@blur="validateMobile"
									required
								/>
								<div v-if="mobileError" class="error-message">{{ mobileError }}</div>
							</div>

							<div class="form-group">
								<label>验证码</label>
								<div class="verification-code-container">
									<input 
										type="tel" 
										v-model="formData.verificationCode" 
										class="form-input verification-input"
										placeholder="请输入验证码"
										required
									/>
									<button 
										type="button" 
										class="get-code-btn"
										:disabled="!canGetCode"
										@click="getVerificationCode"
									>
										{{ verificationCodeText }}
									</button>
								</div>
							</div>
							<button type="button" class="submit-btn" id="completeOrder" @click="saveAllInfo">立即报名咨询</button>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- 悬浮图标 -->
		<div class="floating-icon" v-if="showFloatingIcon" @click="openModal">
			<div class="icon-content">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 6.5V7.5C15 8.3 14.3 9 13.5 9S12 8.3 12 7.5V6.5L6 7V9L12 8.5V9.5C12 10.3 12.7 11 13.5 11S15 10.3 15 9.5V8.5L21 9ZM12 8C10.9 8 10 8.9 10 10V20C10 21.1 10.9 22 12 22C13.1 22 14 21.1 14 20V10C14 8.9 13.1 8 12 8Z" fill="white"/>
				</svg>
				<span class="icon-text">咨询</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { landingPageInsert, getCodeFun, getVerifyCode } from "./apis.js";
	export default {
		name: "LandingPage",
		data() {
			return {
				// 轮播相关数据
				currentSlide: 0,
				isTransitioning: false,
				carouselTimer: null,
				carouselImages: [
					{ src: require('../../img/sm/landingPage/image.png'), alt: '轮播图1' },
					{ src: require('../../img/sm/landingPage/image01.png'), alt: '轮播图2' },
					{ src: require('../../img/sm/landingPage/image02.png'), alt: '轮播图3' },
					{ src: require('../../img/sm/landingPage/image03.png'), alt: '轮播图4' },
					{ src: require('../../img/sm/landingPage/image04.png'), alt: '轮播图5' },
					{ src: require('../../img/sm/landingPage/image05.png'), alt: '轮播图6' }
				],
				
				formData: {
					name: '',
					mobile: '',
					verificationCode: '', // 验证码
				},
				mobileError: '', // 手机号错误提示
				verificationCodeText: '获取验证码', // 验证码按钮文本
				canGetCode: true, // 是否可以获取验证码
				countdown: 0, // 倒计时
				selectedEducation: '', // 选中的学历
				selectedMajor: '', // 选中的专业
				selectedPosition: '', // 选中的职位/身份
				selectedEducationValue: '', // 记录选中的学历值
				selectedMajorValue: '', // 记录选中的专业值
				selectedPositionValue: '', // 记录选中的职位值
				
				// 聊天流程控制
				visibleMessages: [],
				messageIndex: 0,
				showContactForm: false,
				showStats: false,
				showModal: false, // 控制弹窗显示
				showFloatingIcon: false, // 控制悬浮图标显示
				
				// 专业选项
				majorOptions: [
					{ value: 'psychology', label: '心理学' },
					{ value: 'mba', label: '工商管理' },
					{ value: 'education', label: '教育管理' },
					{ value: 'business', label: '国际商务管理' },
					{ value: 'ai', label: '工商管理（AI）' },
					{ value: '会计', label: '工商管理（会计方向）' }
				],
				
				// 学历选项
				educationOptions: [
					{ value: 'college', label: '大专' },
					{ value: 'bachelor', label: '本科' },
					{ value: 'master', label: '硕士' },
					{ value: 'doctor', label: '博士' },
					{ value: 'other', label: '其他' }
				],
				
				// 职位/身份选项
				positionOptions: [
					{ value: 'chairman', label: '集团董事长' },
					{ value: 'entrepreneur', label: '企业家' },
					{ value: 'boss', label: '企业老板' },
					{ value: 'executive', label: '企业高管' },
					{ value: 'elite', label: '职场精英' },
					{ value: 'other', label: '其他' }
				],
				
				
				// 所有消息模板
				allMessages: [
					{
						type: 'university-message',
						content: [
							'为领袖赋能，向未来进阶！',
							'【国际AACSB认证·英法名校】商界领袖硕士/博士项目',
							'免联考·申请入学：硕士1.5年，博士3年，为忙碌的您量身定制。',
							'<span style="color: red; font-weight: bold;">谁适合读：企业家、董事长、企业高管（大专起报，35岁-60岁）</span>。',
							'学什么：前沿创新课程，由学界泰斗与行业大咖亲自带领，解决真实商业问题。',
							'得到什么：加入万余人精英企业家圈层，获取顶级人脉与资本机会（校友会、私董会、研究会）。',
							'立即咨询，锁定席位！'
						]
					},
					{
						type: 'university-message',
						content: [
							'为准确快捷为您咨询，请先回复以下几个问题:',
						]
					},
					{
						type: 'university-message',
						content: ['您目前的学历情况'],
						hasEducationOptions: true
					}
				]
			};
		},
		methods: {
			// 轮播相关方法
			goToSlide(index) {
				if (this.isTransitioning || this.currentSlide === index) return;
				this.isTransitioning = true;
				this.currentSlide = index;
				setTimeout(() => {
					this.isTransitioning = false;
				}, 300);
			},
			
			nextSlide() {
				if (this.isTransitioning) return;
				this.isTransitioning = true;
				this.currentSlide = (this.currentSlide + 1) % this.carouselImages.length;
				setTimeout(() => {
					this.isTransitioning = false;
				}, 300);
			},
			
			startCarousel() {
				this.carouselTimer = setInterval(() => {
					this.nextSlide();
				}, 4000); // 每4秒自动切换
			},
			
			stopCarousel() {
				if (this.carouselTimer) {
					clearInterval(this.carouselTimer);
					this.carouselTimer = null;
				}
			},
			
			// 动态加载 GDT 代码到 head（与 index.html 保持一致）
			// loadGDTToHead() {
			// 	if (typeof window !== 'undefined' && !window.gdt) {
			// 		// 创建并插入 GDT SDK 脚本
			// 		const script = document.createElement('script');
			// 		script.async = true;
			// 		script.src = '//mp.zhls.qq.com/sdk/dmp-sdk-js/gdtevent.min.js';
			// 		document.head.appendChild(script);
					
			// 		// 等待脚本加载完成后执行与 index.html 完全相同的代码
			// 		script.onload = () => {
			// 			// 与 index.html 完全相同的 GDT 初始化代码
			// 			!function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0;n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script','//mp.zhls.qq.com/sdk/dmp-sdk-js/gdtevent.min.js');
			// 			gdt('init','1217048141');
			// 			gdt('track','PAGE_VIEW');
			// 			console.log('GDT 初始化完成 - landingPage');
			// 		};
					
			// 		// 添加 noscript 回退图片（与 index.html 保持一致）
			// 		const noscript = document.createElement('noscript');
			// 		const img = document.createElement('img');
			// 		img.height = 1;
			// 		img.width = 1;
			// 		img.style.display = 'none';
			// 		img.src = 'https://api.datanexus.qq.com/data-nexus-cgi/pixel?user_action_set_id=1217048141&action_type=&noscript=1';
			// 		noscript.appendChild(img);
			// 		document.head.appendChild(noscript);
			// 	}
			// },
			
			// GDT事件上报方法
			trackGDTEvent(eventName, params = {}) {
				if (typeof window !== 'undefined' && window.gdt) {
					window.gdt('track', eventName, params);
					console.log('GDT事件上报:', eventName, params);
				}
			},
			
			// 逐步显示消息
			showNextMessage() {
				if (this.messageIndex < this.allMessages.length) {
					this.visibleMessages.push(this.allMessages[this.messageIndex]);
					this.messageIndex++;
					
					// 滚动到底部
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
			},
			
			// 滚动到底部
			scrollToBottom() {
				const container = this.$refs.chatContainer;
				if (container) {
					container.scrollTop = container.scrollHeight;
				}
			},
			
			// 从消息中选择专业
			selectMajorFromMessage(majorValue) {
				const selectedMajor = this.majorOptions.find(m => m.value === majorValue);
				this.selectedMajor = selectedMajor.label;
				this.selectedMajorValue = majorValue; // 记录选中的专业值
				
				// 立即添加用户回复消息 - 无延迟
				this.visibleMessages.push({
					type: 'user-message',
					content: [selectedMajor.label],
					bubbleClass: 'user-bubble'
				});
				
				// 立即滚动到底部 - 无延迟
				this.$nextTick(() => {
					this.scrollToBottom();
				});
				
				// 快速显示下一个问题
				setTimeout(() => {
					this.visibleMessages.push({
						type: 'university-message',
						content: ['您的职位/身份'],
						hasPositionOptions: true
					});
					
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}, 200);
			},
			
			// 从消息中选择学历
			selectEducationFromMessage(education) {
				const selectedEducation = this.educationOptions.find(e => e.value === education);
				this.selectedEducation = selectedEducation.label;
				this.selectedEducationValue = education; // 记录选中的学历值
				
				// 立即添加用户回复消息 - 无延迟
				this.visibleMessages.push({
					type: 'user-message',
					content: [selectedEducation.label],
					bubbleClass: 'user-bubble'
				});
				
				// 立即滚动到底部 - 无延迟
				this.$nextTick(() => {
					this.scrollToBottom();
				});
				
				// 快速显示下一个问题
				setTimeout(() => {
					this.visibleMessages.push({
						type: 'university-message',
						content: ['您意向的专业'],
						hasMajorOptions: true
					});
					
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}, 200);
			},
			
			// 从消息中选择职位/身份
			selectPositionFromMessage(position) {
				const selectedPosition = this.positionOptions.find(p => p.value === position);
				this.selectedPosition = selectedPosition.label;
				this.selectedPositionValue = position;
				
				// 立即添加用户回复消息 - 无延迟
				this.visibleMessages.push({
					type: 'user-message',
					content: [selectedPosition.label],
					bubbleClass: 'user-bubble'
				});
				
				// 立即滚动到底部 - 无延迟
				this.$nextTick(() => {
					this.scrollToBottom();
				});
				
				// 直接显示弹窗
				setTimeout(() => {
					this.showModal = true;
				}, 200);
			},
			
			



			// 关闭弹窗
			closeModal() {
				this.showModal = false;
				// 延迟显示悬浮图标
				setTimeout(() => {
					this.showFloatingIcon = true;
				}, 200);
			},
			
			// 打开弹窗
			openModal() {
				this.showModal = true;
				this.showFloatingIcon = false;
			},
			
			// 验证手机号
			validateMobile() {
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (this.formData.mobile === '') {
					this.mobileError = '';
					return;
				}
				if (!phoneRegex.test(this.formData.mobile)) {
					this.mobileError = '请输入正确的11位手机号码';
				} else {
					this.mobileError = '';
				}
			},
			
			// 获取验证码
			async getVerificationCode() {
				// 验证手机号
				if (!this.formData.mobile) {
					this.$layer.msg('请先输入手机号码', { time: 2 });
					return;
				}
				
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(this.formData.mobile)) {
					this.$layer.msg('请输入正确的11位手机号码', { time: 2 });
					return;
				}
				
				if (!this.canGetCode) {
					return;
				}
				
				try {
					const params = {
						mobile: this.formData.mobile,
					};
					const { data } = await getCodeFun(params);
					
					if (data.code === 1000) {
						this.$layer.msg(data.message || '验证码已发送', { time: 2 });
						this.startCountdown();
					} else {
						this.$layer.msg(data.message || '获取验证码失败', { time: 2 });
					}
				} catch (error) {
					console.error('获取验证码失败:', error);
					this.$layer.msg('获取验证码失败，请稍后重试', { time: 2 });
				}
			},
			
			// 开始倒计时
			startCountdown() {
				this.canGetCode = false;
				this.countdown = 60;
				this.verificationCodeText = `${this.countdown}s后重新获取`;
				
				const timer = setInterval(() => {
					this.countdown--;
					if (this.countdown <= 0) {
						clearInterval(timer);
						this.canGetCode = true;
						this.verificationCodeText = '获取验证码';
						this.countdown = 0;
					} else {
						this.verificationCodeText = `${this.countdown}s后重新获取`;
					}
				}, 1000);
			},
			
			// 验证验证码
			async verifyCode() {
				if (!this.formData.verificationCode) {
					this.$layer.msg('请输入验证码', { time: 2 });
					return false;
				}
				
				try {
					const params = {
						mobile: this.formData.mobile,
						mobileCode: this.formData.verificationCode,
					};
					const { data } = await getVerifyCode(params);
					
					if (data.code === 1000) {
						return true;
					} else {
						this.$layer.msg(data.message || '验证码错误', { time: 2 });
						return false;
					}
				} catch (error) {
					console.error('验证验证码失败:', error);
					this.$layer.msg('验证码验证失败，请稍后重试', { time: 2 });
					return false;
				}
			},
			
			async saveAllInfo() {
				// 验证表单
				if (!this.formData.name) {
					this.$layer.msg('请输入姓名', { time: 1 });
					return;
				}
				if (!this.formData.mobile) {
					this.$layer.msg('请输入手机号码', { time: 1 });
					return;
				}
				
				// 手机号11位校验
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(this.formData.mobile)) {
					this.$layer.msg('请输入正确的11位手机号码', { time: 2 });
					return;
				}
				
				// 验证验证码
				if (!this.formData.verificationCode) {
					this.$layer.msg('请输入验证码', { time: 2 });
					return;
				}
				
				// 先验证验证码，验证通过后再提交表单
				const isCodeValid = await this.verifyCode();
				if (isCodeValid) {
					this.submitForm();
				}
			},
			
			// async submitForm() {
			// 	// 这里处理表单提交逻辑
			// 	console.log('提交表单数据:', this.formData);
				
			// 	// GDT事件上报 - 表单提交完成 (按照图片示例)
			// 	this.trackGDTEvent('COMPLETE_ORDER', {
			// 		education: this.selectedEducation,
			// 		major: this.selectedMajor,
			// 		position: this.selectedPosition,
			// 		name: this.formData.name,
			// 		mobile: this.formData.mobile
			// 	});
			// 	console.log('提交表单数据:', this.formData);
			// 	this.$layer.msg('提交成功！我们将尽快联系您。', { time: 3 });
			// 	// 提交成功后关闭弹窗，不显示悬浮图标
			// 	this.showModal = false;
			// 	this.showFloatingIcon = false;
			// },
			async submitForm() {
				// 这里处理表单提交逻辑
				console.log('提交表单数据:', this.formData);
				let params = {
					name: this.formData.name,
					mobile: this.formData.mobile,
					edu: this.selectedEducation,
					major: this.selectedMajor,
					post: this.selectedPosition,
					channelCode: '视频号广告_英法全专业68525368_微盟',
                    sourceType:"视频号广告_英法全专业68525368_微盟",
					type:1  // 默认不传就是推的螳螂，传1就是推腾讯
				}
				console.log("params",params);
				let {data} = await landingPageInsert(params);
				console.log("data",data);
				if (data.code == 1000) {
					console.log('提交成功！我们将尽快联系您。', { time: 3 });
				} else {
					console.log('提交失败！', data.message);
				}
				// 按照图片示例的GDT事件上报格式
				if (typeof window !== 'undefined' && window.gdt) {
					let rawDataStr = JSON.stringify({
						'标题': '数据上报',
						'学历': this.selectedEducation,
						'职位/身份': this.selectedPosition,
						'专业': this.selectedMajor,
						'姓名': this.formData.name,
						'联系方式': this.formData.mobile
					});
					window.gdt('track', 'RESERVATION', {
						'object':rawDataStr,
					});
					console.log('GDT事件上报: CONSULT', {
						'title': '数据上报',
						'education': this.selectedEducation,
						'major': this.selectedMajor,
						'position': this.selectedPosition,
						'name': this.formData.name,
						'mobile': this.formData.mobile
					});
					// 显示成功消息
				    // this.$layer.msg('提交成功！我们将尽快联系您。', { time: 3 });
				} else {
					alert('GDT未加载或初始化失败');
				}
				
				// 提交成功后关闭弹窗，不显示悬浮图标
				this.showModal = false;
				this.showFloatingIcon = false;
			},
			
			
			// 启动聊天流程
			startChatFlow() {
				// 显示统计信息
				this.showStats = true;
				
				// 延迟开始显示消息
				setTimeout(() => {
					this.showNextMessage();
					
					// 继续显示后续消息 - 加快速度
					const messageInterval = setInterval(() => {
						if (this.messageIndex < this.allMessages.length) {
							this.showNextMessage();
						} else {
							clearInterval(messageInterval);
						}
					}, 300); // 进一步加快消息显示
				}, 300); // 减少初始延迟
			}
		},
		mounted() {
			// 动态加载 GDT 代码到 head
			// this.loadGDTToHead();
			// 启动轮播
			this.startCarousel();
			// 启动聊天流程
			this.startChatFlow();
		},
		
		beforeDestroy() {
			// 清理轮播定时器
			this.stopCarousel();
		}
	};
</script>

<style scoped>
	/* 基础样式重置 */
	* {
		box-sizing: border-box;
	}

	.chat-landing-page {
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		line-height: 1.6;
		color: #333;
		background-color: #f8f9fa;
		min-height: 100vh;
	}

	/* 轮播图样式 */
	.carousel-container {
		position: relative;
		width: 100%;
		height: 250px;
		overflow: hidden;
		background: #fff;
	}

	.carousel-wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		transition: transform 0.3s ease-in-out;
		will-change: transform;
	}

	.carousel-slide {
		width: 100%;
		height: 100%;
		position: relative;
		flex: 0 0 100%;
	}

	.carousel-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: center;
		background-color: #f8f9fa;
	}

	/* 轮播指示器 */
	.carousel-indicators {
		position: absolute;
		bottom: 15px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		gap: 8px;
		z-index: 10;
	}

	.indicator {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, 0.5);
		cursor: pointer;
		transition: all 0.3s ease;
	}

	.indicator.active {
		background-color: #dc2626;
		transform: scale(1.2);
	}

	.indicator:hover {
		background-color: rgba(255, 255, 255, 0.8);
	}


	/* 聊天容器 */
	.chat-container {
		padding: 1rem;
		max-width: 100%;
		margin: 0 auto;
		max-height: calc(100vh - 80px);
		overflow-y: auto;
		scroll-behavior: smooth;
	}

	/* 消息样式 */
	.message {
		display: flex;
		margin-bottom: 1rem;
		align-items: flex-start;
		opacity: 0;
		transform: translateY(20px);
		animation: messageSlideIn 0.2s ease-out forwards;
	}

	/* 用户消息立即显示 */
	.user-message {
		opacity: 1;
		transform: translateY(0);
		animation: userMessageSlideIn 0.3s ease-out forwards;
	}

	@keyframes messageSlideIn {
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes userMessageSlideIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.university-message {
		justify-content: flex-start;
	}

	.user-message {
		justify-content: flex-end;
	}

	/* 头像样式 */
	.message-avatar {
		width: 40px;
		height: 40px;
		flex-shrink: 0;
	}

	.uibe-logo {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
	}

	.logo-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 50%;
	}

	.logo-text {
		font-size: 0.7rem;
		line-height: 1;
	}

	.logo-year {
		font-size: 0.6rem;
		line-height: 1;
		opacity: 0.8;
	}

	.user-avatar {
		width: 40px;
		height: 40px;
		background: #e9ecef;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.user-icon {
		font-size: 1.2rem;
	}

	/* 消息气泡 */
	.message-bubble {
		max-width: 70%;
		margin: 0 0.5rem;
	}

	.university-message .message-bubble {
		background: #fff;
		border-radius: 18px 18px 18px 4px;
		padding: 0.8rem 1rem;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	}

	.user-bubble {
		background: #e9ecef;
		border-radius: 18px 18px 4px 18px;
		padding: 0.8rem 1rem;
	}

	.message-content p {
		margin: 0.3rem 0;
		font-size: 0.9rem;
		line-height: 1.4;
		text-align: left;
	}

	.message-content p:first-child {
		margin-top: 0;
	}

	.message-content p:last-child {
		margin-bottom: 0;
	}

	/* 消息内专业选项 */
	.major-options-inline {
		margin-top: 0.8rem;
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	.major-option-tag {
		background: #dc2626;
		color: white;
		padding: 0.4rem 0.8rem;
		border-radius: 15px;
		font-size: 0.8rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: inline-block;
		border: 1px solid #dc2626;
	}

	.major-option-tag:hover {
		background: #b91c1c;
		border-color: #b91c1c;
		transform: translateY(-1px);
		box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
	}

	.major-option-tag:active {
		background: #991b1b;
		border-color: #991b1b;
		transform: translateY(0);
	}

	/* 消息内学历选项 */
	.education-options-inline {
		margin-top: 0.8rem;
		display: block;
	}

	.education-option-tag {
		background: #dc2626;
		color: white;
		padding: 0.4rem 0.8rem;
		border-radius: 15px;
		font-size: 0.8rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: inline-block;
		text-align: center;
		border: 1px solid #dc2626;
		white-space: nowrap;
		margin: 0.2rem;
	}

	.education-option-tag:hover {
		background: #b91c1c;
		border-color: #b91c1c;
		transform: translateY(-1px);
		box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
	}

	.education-option-tag:active {
		background: #991b1b;
		border-color: #991b1b;
		transform: translateY(0);
	}

	/* 职位选项样式 */
	.position-options-inline {
		margin-top: 0.8rem;
		display: block;
	}

	.position-option-tag {
		background: #dc2626;
		color: white;
		padding: 0.4rem 0.8rem;
		border-radius: 15px;
		font-size: 0.8rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: inline-block;
		text-align: center;
		border: 1px solid #dc2626;
		white-space: nowrap;
		margin: 0.2rem;
	}

	.position-option-tag:hover {
		background: #b91c1c;
		border-color: #b91c1c;
		transform: translateY(-1px);
		box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
	}

	.position-option-tag:active {
		background: #991b1b;
		border-color: #991b1b;
		transform: translateY(0);
	}


	/* 弹窗样式 */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: flex-end;
		z-index: 1000;
		animation: fadeIn 0.3s ease-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.modal-container {
		background: #fff;
		border-radius: 12px 12px 0 0;
		width: 100%;
		max-width: 100%;
		max-height: 60vh;
		overflow-y: auto;
		box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.2);
		animation: slideUp 0.3s ease-out;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}

	@keyframes slideUp {
		from {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1.5rem 1.5rem 1rem 1.5rem;
		border-bottom: 1px solid #e5e7eb;
	}

	.modal-header h3 {
		margin: 0;
		font-size: 1.25rem;
		font-weight: 600;
		color: #1f2937;
	}

	.close-btn {
		background: none;
		border: none;
		font-size: 1.5rem;
		color: #6b7280;
		cursor: pointer;
		padding: 0;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		transition: all 0.2s ease;
	}

	.close-btn:hover {
		background-color: #f3f4f6;
		color: #374151;
	}

	.modal-body {
		padding: 1.5rem;
	}

	/* 联系表单 */
	.contact-form {
		background: #fff;
		padding: 1rem;
		border-radius: 8px;
		margin: 1rem 0;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	}

	.registration-form {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		text-align: left;
	}

	.form-group {
		display: flex;
		flex-direction: column;
		margin-bottom: 1rem;
		text-align: left;
	}

	.form-group label {
		font-weight: 500;
		color: #374151;
		margin-bottom: 0.5rem;
		font-size: 0.9rem;
		text-align: left;
	}

	.form-input {
		padding: 0.8rem;
		border: 1px solid #ddd;
		border-radius: 6px;
		font-size: 0.9rem;
		transition: border-color 0.3s ease;
		background-color: #fff;
		text-align: left;
	}

	.form-input:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
	}

	.form-input.error {
		border-color: #dc2626;
		box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
	}

	.error-message {
		color: #dc2626;
		font-size: 0.8rem;
		margin-top: 0.3rem;
		text-align: left;
	}

	/* 验证码相关样式 */
	.verification-code-container {
		display: flex;
		gap: 0.5rem;
		align-items: flex-start;
	}

	.verification-input {
		flex: 1;
		margin-bottom: 0;
	}

	.get-code-btn {
		background: #dc2626;
		color: #fff;
		border: none;
		padding: 0.8rem 1rem;
		border-radius: 6px;
		font-size: 0.9rem;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		white-space: nowrap;
		min-width: 120px;
	}

	.get-code-btn:hover:not(:disabled) {
		background: #b91c1c;
	}

	.get-code-btn:disabled {
		background: #9ca3af;
		cursor: not-allowed;
		opacity: 0.6;
	}


	.form-input[readonly] {
		background-color: #f9fafb;
		color: #6b7280;
		cursor: not-allowed;
	}


	.submit-btn {
		background: #dc2626;
		color: #fff;
		border: none;
		padding: 1rem;
		border-radius: 6px;
		font-size: 1rem;
		font-weight: 600;
		cursor: pointer;
		transition: background-color 0.3s ease;
		margin-top: 0.5rem;
	}

	.submit-btn:hover {
		background: #b91c1c;
	}

	/* 悬浮图标样式 */
	.floating-icon {
		position: fixed;
		right: 20px;
		bottom: 80px;
		z-index: 999;
		cursor: pointer;
		animation: floatIn 0.5s ease-out;
	}

	@keyframes floatIn {
		from {
			transform: translateX(100px);
			opacity: 0;
		}
		to {
			transform: translateX(0);
			opacity: 1;
		}
	}

	.icon-content {
		background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
		border-radius: 25px;
		padding: 12px 16px;
		display: flex;
		align-items: center;
		gap: 8px;
		box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
	}

	.icon-content::before {
		content: '';
		position: absolute;
		top: 0;
		left: -100%;
		width: 100%;
		height: 100%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
		transition: left 0.5s;
	}

	.icon-content:hover::before {
		left: 100%;
	}

	.icon-content:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);
	}

	.icon-content:active {
		transform: translateY(0);
	}

	.icon-text {
		color: white;
		font-size: 14px;
		font-weight: 500;
		white-space: nowrap;
	}

	/* 响应式设计 */
	@media (max-width: 480px) {
		.carousel-container {
			height: 220px;
		}
		
		.indicator {
			width: 6px;
			height: 6px;
		}
		
		.carousel-indicators {
			bottom: 10px;
			gap: 6px;
		}

		.chat-container {
			padding:2rem 0.5rem;
		}

		.message-bubble {
			max-width: 80%;
		}

		.major-option-tag {
			font-size: 0.75rem;
			padding: 0.3rem 0.6rem;
		}

		.education-options-inline {
			flex-direction: column;
		}

		.education-option-tag {
			font-size: 0.75rem;
			padding: 0.3rem 0.6rem;
		}

		/* 弹窗移动端样式 */
		.modal-container {
			width: 100%;
			max-height: 70vh;
		}

		.modal-header {
			padding: 1rem;
		}

		.modal-body {
			padding: 1rem;
		}

		.modal-header h3 {
			font-size: 1.1rem;
		}

		/* 悬浮图标移动端样式 */
		.floating-icon {
			right: 15px;
			bottom: 60px;
		}

		.icon-content {
			padding: 10px 14px;
		}

		.icon-text {
			font-size: 13px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/sm/landingPage.vue